import React, { Dispatch, SetStateAction } from 'react';
import { DaySelector } from '../DaySelector';
import classes from './PostingPlanMobileNavigation.module.scss';
import classNames from 'classnames';
import { StartOfWeekFormatSetting, TimeslotDay } from '../../../../models/graphql';

export type NavigationDayType = {
  day: TimeslotDay;
  displayValue: string;
};

export type PostingPlanMobileNavigationViewProps = {
  dayNavigation: NavigationDayType[];
  selectedDay: TimeslotDay;
  setSelectedDay: Dispatch<SetStateAction<TimeslotDay>>;
  startDayWeek: StartOfWeekFormatSetting;
};

export const PostingPlanMobileNavigationView = (props: PostingPlanMobileNavigationViewProps): JSX.Element => {
  const globalClasses = classNames('grid-x', 'align-justify', 'padding-top-small-16', 'padding-bottom-small-16');
  return (
    <div className={classes.PostingPlanMobileNavigation}>
      <div className={globalClasses}>
        {props.dayNavigation.map((day, index) => (
          <div className={'cell shrink'} key={index}>
            <DaySelector
              selected={day.day === props.selectedDay}
              action={() => {
                props.setSelectedDay(day.day);
              }}>
              {day.displayValue}
            </DaySelector>
          </div>
        ))}
      </div>
    </div>
  );
};
